import { type RouteRecordRaw } from "vue-router";
import { RouteNames } from "@shared/types/localTypes/router";
import { usePartnerStore } from "@shared/stores/partner/partner.ts";

const routes: RouteRecordRaw[] = [
  {
    path: "/" + RouteNames.Partnerships,
    name: RouteNames.Partnerships,
    component: () => import("@/views/partnerPortal/portal/PartnersBase.vue"),
    redirect: { name: RouteNames.Partners },
    meta: { requiresAuth: true },
    children: [
      {
        path: "",
        name: RouteNames.Partners,
        component: () =>
          import("@/views/partnerPortal/portal/PartnersPage.vue"),
        beforeEnter: async () => {
          const partnerStore = usePartnerStore();
          partnerStore.clearPartnerId();
          await partnerStore.retrievePartners();

          const partners = partnerStore.partnerCompanyNames?.partners;
          if (!partners?.length) {
            return;
          }
          // no name exists just redirect to partner page

          const isSalesforceNameExists = partners.every(
            (partner) =>
              !!partner.partnerCompanyName && partner.partnerCompanyName !== "",
          );

          if (partners.length === 1 || !isSalesforceNameExists) {
            await partnerStore.setPartnerId(partners[0].crmPartnerId);

            return {
              name: RouteNames.Partner,
              params: {
                id: partners[0].crmPartnerId,
              },
            };
          }
        },
      },
      {
        path: ":id",
        name: RouteNames.Partner,
        component: () => import("@/views/partnerPortal/portal/PartnerPage.vue"),
        beforeEnter: (to) => {
          const { id } = to.params;
          const partnerStore = usePartnerStore();
          partnerStore.setPartnerId(id as string);
          partnerStore.retrievePartners();
        },
      },
    ],
  },
];

export default routes;
